import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import "./App.css";
import Hero from './images/illustration-features-tab-3.svg';

const FeaturesTab3 = () => {
    return (
        <main className='main-fs'>
            <div className="second-section">
                <img src={Hero} />
            </div>
            <div className='first-section fs'>
                <h1>Share your bookmarks</h1>
                <p>Easily share your bookmarks and collections with others. Create a shareable 
                link that you can send at the click of a button.</p>
                <button className='btn1'>
                    More Info
                </button>
            </div>
            
        </main>
    );
}

export default FeaturesTab3;
